/* eslint-disable camelcase */
import PropTypes from 'prop-types'
import InputNumber from '../forms/InputNumber'
import TravelDatepicker from '../helpers/TravelDatepicker'
import messages from '../../messages'
import './styles/conservation-order.scss'
import useAvailableDates from './hooks/useAvailableDates'
import { FormattedMessage } from 'react-intl'
import { useState, useMemo } from 'react'
import { getTravelDomain } from 'utils'
import PriceConverter, { convertCurrency } from '../helpers/PriceConverter'
import { createUrl } from '../../localized-urls'
import { setBrandValue } from '../../gtm'
import { parseQuery } from '../../utils'

ConservationOrderSummary.propTypes = {
  activityId: PropTypes.number.isRequired,
  acitivityPricing: PropTypes.shape({
    comparePrice: PropTypes.shape({
      origin_currency: PropTypes.string.isRequired,
      origin_value: PropTypes.string.isRequired,
    }).isRequired,
    price: PropTypes.shape({
      origin_currency: PropTypes.string.isRequired,
      origin_value: PropTypes.string.isRequired,
    }).isRequired,
  }),
}

export default function ConservationOrderSummary({
  activityId,
  acitivityPricing,
}) {
  const [quantity, setQuantity] = useState(1)
  const [date, setDate] = useState(null)
  const { dates, availabilities } = useAvailableDates(activityId)

  const { origin_value, origin_currency } = acitivityPricing.price
  const isFree = parseInt(origin_value) === 0
  const updateQuantity = (val) => setQuantity(val)

  const onDateSelect = ({ dateFrom }) => {
    setDate(dateFrom)
  }

  const maximumAvailability = useMemo(() => {
    if(availabilities) {
      const selectedDate =
        availabilities.find((item) => item.date === date) || {}
      return selectedDate.availableSeats
    }
  }, [date, availabilities])

  const handleCheckout = () => {
    const query = parseQuery() || {}
    if(!date) {
      document.querySelector('.travel-datepicker').click()
      return false
    }

    window.dataLayer.push({
      event: 'addToCart',
      ecommerce: {
        currencyCode: window.currency,
        add: {
          products: [
            {
              name: window.activityTitle,
              id: +window.activityId,
              price: convertCurrency(
                origin_value,
                origin_currency,
                window.currency,
                false,
                true,
              ).toFixed(2),
              brand: setBrandValue({
                title: window.shopName,
                affiliateId: window.isProDiver ? false : window.shopId,
                id: window.shopId,
              }),
              category: `${window.activityType} (Adventures)`,
              quantity,
            },
          ],
        },
      },
    })

    const checkoutURL = createUrl(
      'checkout_adventures',
      {
        date,
        activityId,
      },
      `?participants=${quantity}${window.isWidget ? '&widget=true' : ''}${query.showIntercom ? `&showIntercom=${query.showIntercom}` : ''}${query.aid ? `&aid=${query.aid}` : ''}${query.landingPage ? `&landingPage=${query.landingPage}` : ''} ${query.currency_code ? `&currency_code=${query.currency_code}` : ''}${query.social_link ? `&social_link=${query.social_link}` : ''}`,
    )
    window.location.href = `${getTravelDomain()}${checkoutURL}`
  }

  return (
    <div className='conservation-order'>
      <div className='conservation-order__number-input'>
        <InputNumber
          value={quantity}
          onChange={updateQuantity}
          plusMinusSeparate
          minNumber={1}
          maxNumber={maximumAvailability}
        />
      </div>
      {quantity >= maximumAvailability && (
        <div className='warning-message mtm mbh'>
          <FormattedMessage
            id='maximum_limit'
            defaultMessage='There are only {qty, plural, one {# spot} other {# spots}} left on that date'
            values={{ qty: maximumAvailability }}
          />
        </div>
      )}
      <label className='conservation-order__date-field'>
        <span className='conservation-order__date-field-label'>
          <FormattedMessage id='date' defaultMessage='Date' />
        </span>
        <TravelDatepicker
          labelFrom={messages.selectDate}
          className='travel-datepicker'
          availableDatesAdventures={dates}
          disableInput
          closeOnSelect
          callback={onDateSelect}
          isDiveCenterCalendar
          showLegend
        />
      </label>

      <div className='conservation-order__total'>
        {!isFree && (
          <span className='conservation-order__calculation'>
            {quantity} x{' '}
            <PriceConverter
              amount={origin_value}
              currency={origin_currency}
              conversionPercent
            />{' '}
            / <FormattedMessage id='person' defaultMessage='person' />
          </span>
        )}

        <div className='conservation-order__total-price'>
          <FormattedMessage id='total' defaultMessage='Total' />
          {isFree ? (
            <FormattedMessage id='free' defaultMessage='Free' />
          ) : (
            <PriceConverter
              amount={origin_value * quantity}
              currency={origin_currency}
              conversionPercent
            />
          )}
        </div>
      </div>
      <button className='btn-guides-blue' onClick={handleCheckout}>
        {isFree ? (
          <FormattedMessage id='sign-up' defaultMessage='Sign up' />
        ) : (
          <FormattedMessage id='checkout' defaultMessage='Checkout' />
        )}
      </button>
    </div>
  )
}
